/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Increase_Playback_SpeedInputs */



/**
* | output |
* | --- |
* | "Increase the playback speed of the player. Playback rates include 0.25x - 16x" |
*
* @param {Shortcut_Keys_Desc_Increase_Playback_SpeedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_increase_playback_speed = /** @type {((inputs?: Shortcut_Keys_Desc_Increase_Playback_SpeedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Increase_Playback_SpeedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Augmenter la vitesse de lecture. Les vitesses vont de 0,25x a 16x")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erhöhen Sie die Wiedergabegeschwindigkeit des Players. Mögliche Wiedergabegeschwindigkeiten sind 0,25x bis 16x.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aumenta la velocità di riproduzione del lettore. Le velocità di riproduzione includono 0,25x - 16x")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Увеличьте скорость воспроизведения в плеере. Скорость воспроизведения составляет от 0,25x до 16x.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aumenta la velocidad de reproducción del reproductor. Las velocidades de reproducción van de 0,25x a 16x.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提高播放器的播放速度。播放速度范围为 0.25 倍至 16 倍。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレーヤーの再生速度を上げます。再生速度は0.25倍速から16倍速まであります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लेयर की प्लेबैक गति बढ़ाएँ। प्लेबैक गति 0.25x से 16x तक है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aumente a velocidade de reprodução do player. As taxas de reprodução incluem 0,25x a 16x.")
	return /** @type {LocalizedString} */ ("Increase the playback speed of the player. Playback rates include 0.25x - 16x")
});